const EDIT = "edit/:id";
const SURVEY = "survey/:id";
const DETAIL = "detail/:id";
const CREATE = "create";
const ORG_CHART = "org-chart";
const REALMS = "/realms";
const INDEX = "/";
const LOGIN = "/login";
const EMPLOYEES = "/employees";
const LEAVES = "/leaves";
const OVERTIME = "/overtime";
const OVERTIME_APPROVAL_PROCESS = "/overtime-approval-process";
const UNITS = "/units";
const FACTORIES = "/factories";
const MY_LEAVES = "/my-leaves";
const MY_OVERTIMES = "/my-overtimes";
const ASSIGNMENTS = "/assignments";
const LEAVE_APPROVAL_PROCESS = "/leave-approval-process";
const CALENDAR_HOLIDAYS = "/calendar-holidays";
const ANNOUNCEMENT = "/announcement";
const BULK_LEAVES = "/bulk-leaves";
const GUESTS = "/guests";
const GATES = "/gates";
const LEAVE_TYPES = "/leave-types";
const ACTIVITY = "/activity";
const LEAVE_RIGHT_REPORTS = "/leave-right-reports";
const GUEST_ENTRANCE_REPORTS = "/guest-entrance-reports";
const EMPLOYMENT_START_REPORTS = "/employment-start-reports";
const USER_LEAVE_REPORTS = "/user-leave-reports";
const EMPLOYEE_SHIFT_REPORTS = "/employee-shift-reports";
const PUANTAJ = "/puantaj";
const DAILY_SHIFTS = "/daily-shifts";
const APP_VERSION = "/app-version";
const VERSION_CHECK = "/version-check";
const WORK_CALENDAR = "/work-calendar";
const SALARY_ACCOUNT = "/salary-account";
const FEATURE_FLAGS = "/feature-flags";
const ERP_CONSENT = "/oauth/erp-consent";
const MIKRO_PERSONNEL_SYNC = "/mikro-personnel-sync";
const PERSONNEL_FILE_REQUIREMENT_DEFINITIONS =
  "/personnel-file-requirement-definitions";
const PERSONNEL_FILE_FLOWS = "/personnel-file-flows";

export const ROUTES = {
  MEAL_PLANS: { PATH: "/meal-plans" },
  APP_USAGE: { PATH: "/app-usage" },
  SHIFT_PLANS: { PATH: "/shift-plans" },
  COMPANY_DEVICES: { PATH: "/company-devices" },
  WORKSPACE: { PATH: "/workspace" },
  ERP_CONSENT: { PATH: ERP_CONSENT },
  INDEX: { PATH: INDEX },
  LOGIN: { PATH: LOGIN },
  EMPLOYEES: {
    PATH: EMPLOYEES,
    EDIT: { PATH: `${EMPLOYEES}/${EDIT}` },
    CREATE: { PATH: `${EMPLOYEES}/${CREATE}` },
  },
  LEAVES: {
    PATH: LEAVES,
    DETAIL: { PATH: `${LEAVES}/${DETAIL}` },
  },
  OVERTIME: {
    PATH: OVERTIME,
    DETAIL: { PATH: `${OVERTIME}/${DETAIL}` },
  },
  ASSIGNMENTS: { PATH: ASSIGNMENTS },
  OVERTIME_APPROVAL_PROCESS: {
    PATH: OVERTIME_APPROVAL_PROCESS,
    EDIT: { PATH: `${OVERTIME_APPROVAL_PROCESS}/${EDIT}` },
  },
  FACTORIES: {
    PATH: FACTORIES,
    EDIT: { PATH: `${FACTORIES}/${EDIT}` },
  },
  UNITS: {
    PATH: UNITS,
    EDIT: { PATH: `${UNITS}/${EDIT}` },
    ORG_CHART: { PATH: `${UNITS}/${ORG_CHART}` },
  },
  LEAVE_TYPES: {
    PATH: LEAVE_TYPES,
    EDIT: { PATH: `${LEAVE_TYPES}/${EDIT}` },
  },
  PERSONNEL_FILE_REQUIREMENT_DEFINITIONS: {
    PATH: PERSONNEL_FILE_REQUIREMENT_DEFINITIONS,
    EDIT: { PATH: `${PERSONNEL_FILE_REQUIREMENT_DEFINITIONS}/${EDIT}` },
  },
  PERSONNEL_FILE_FLOWS: {
    PATH: PERSONNEL_FILE_FLOWS,
  },
  MY_LEAVES: {
    PATH: MY_LEAVES,
  },
  MY_OVERTIMES: {
    PATH: MY_OVERTIMES,
  },
  GUESTS: {
    PATH: GUESTS,
    EDIT: { PATH: `${GUESTS}/${EDIT}` },
    DETAIL: { PATH: `${GUESTS}/${DETAIL}` },
  },
  GATES: {
    PATH: GATES,
    EDIT: { PATH: `${GATES}/${EDIT}` },
  },
  LEAVE_APPROVAL_PROCESS: {
    PATH: LEAVE_APPROVAL_PROCESS,
    EDIT: { PATH: `${LEAVE_APPROVAL_PROCESS}/${EDIT}` },
  },
  WORK_CALENDAR: {
    PATH: WORK_CALENDAR,
    EDIT: { PATH: `${WORK_CALENDAR}/${EDIT}` },
  },
  CALENDAR_HOLIDAYS: {
    PATH: CALENDAR_HOLIDAYS,
    EDIT: { PATH: `${CALENDAR_HOLIDAYS}/${EDIT}` },
  },
  REALMS: {
    PATH: REALMS,
    EDIT: { PATH: `${REALMS}/${EDIT}` },
    DETAIL: { PATH: `${REALMS}/${DETAIL}` },
  },
  ANNOUNCEMENT: {
    PATH: ANNOUNCEMENT,
    EDIT: { PATH: `${ANNOUNCEMENT}/${EDIT}` },
    SURVEY: { PATH: `${ANNOUNCEMENT}/${SURVEY}` },
  },
  BULK_LEAVES: {
    PATH: BULK_LEAVES,
  },
  LEAVE_RIGHT_REPORTS: {
    PATH: LEAVE_RIGHT_REPORTS,
  },
  GUEST_ENTRANCE_REPORTS: {
    PATH: GUEST_ENTRANCE_REPORTS,
  },
  EMPLOYMENT_START_REPORTS: {
    PATH: EMPLOYMENT_START_REPORTS,
  },
  USER_LEAVE_REPORTS: {
    PATH: USER_LEAVE_REPORTS,
  },
  EMPLOYEE_SHIFT_REPORTS: {
    PATH: EMPLOYEE_SHIFT_REPORTS,
  },
  PUANTAJ: { PATH: PUANTAJ },
  DAILY_SHIFTS: {
    PATH: DAILY_SHIFTS,
  },
  ACTIVITY: {
    PATH: ACTIVITY,
  },

  APP_VERSION: {
    PATH: APP_VERSION,
    CREATE: { PATH: `${APP_VERSION}/${CREATE}` },
    EDIT: { PATH: `${APP_VERSION}/${EDIT}` },
  },

  VERSION_CHECK: {
    PATH: VERSION_CHECK,
  },
  SALARY_ACCOUNT: {
    PATH: SALARY_ACCOUNT,
  },
  FEATURE_FLAGS: {
    PATH: FEATURE_FLAGS,
    EDIT: { PATH: `${FEATURE_FLAGS}/${EDIT}` },
  },
  MIKRO_PERSONNEL_SYNC: {
    PATH: MIKRO_PERSONNEL_SYNC,
  },
};

export const URLS = {
  MEAL_PLANS: "/meal-plans",
  APP_USAGE: "/app-usage",
  SHIFT_PLANS: "/shift-plans",
  WORKSPACE: "/workspace",
  INDEX,

  LOGIN,

  EMPLOYEES,
  EMPLOYEES_EDIT: (id: string) => `${EMPLOYEES}/${EDIT.replace(":id", id)}`,
  EMPLOYEES_CREATE: `${EMPLOYEES}/${CREATE}`,

  LEAVES,
  LEAVES_DETAIL: (id: string) => `${LEAVES}/${DETAIL.replace(":id", id)}`,

  ASSIGNMENTS,

  OVERTIME,
  OVERTIME_DETAIL: (id: string) => `${OVERTIME}/${DETAIL.replace(":id", id)}`,

  OVERTIME_APPROVAL_PROCESS,
  OVERTIME_APPROVAL_PROCESS_EDIT: (id: string) =>
    `${OVERTIME_APPROVAL_PROCESS}/${EDIT.replace(":id", id)}`,

  FACTORIES,
  FACTORIES_EDIT: (id: string) => `${FACTORIES}/${EDIT.replace(":id", id)}`,

  UNITS,
  UNITS_EDIT: (id: string) => `${UNITS}/${EDIT.replace(":id", id)}`,
  UNITS_ORG_CHART: `${UNITS}/${ORG_CHART}`,

  MY_LEAVES,
  MY_OVERTIMES,

  GUESTS: GUESTS,
  GUESTS_EDIT: (id: string) => `${GUESTS}/${EDIT.replace(":id", id)}`,
  GUESTS_DETAIL: (id: string) => `${GUESTS}/${DETAIL.replace(":id", id)}`,

  GATES: GATES,
  GATES_EDIT: (id: string) => `${GATES}/${EDIT.replace(":id", id)}`,

  WORK_CALENDAR: WORK_CALENDAR,
  WORK_CALENDAR_EDIT: (id: string) =>
    `${WORK_CALENDAR}/${EDIT.replace(":id", id)}`,

  LEAVE_TYPES: LEAVE_TYPES,
  LEAVE_TYPES_EDIT: (id: string) => `${LEAVE_TYPES}/${EDIT.replace(":id", id)}`,

  PERSONNEL_FILE_FLOWS,
  PERSONNEL_FILE_REQUIREMENT_DEFINITIONS,
  PERSONNEL_FILE_REQUIREMENT_DEFINITIONS_EDIT: (id: string) =>
    `${PERSONNEL_FILE_REQUIREMENT_DEFINITIONS}/${EDIT.replace(":id", id)}`,

  FEATURE_FLAGS: FEATURE_FLAGS,
  FEATURE_FLAGS_EDIT: (id: string) =>
    `${FEATURE_FLAGS}/${EDIT.replace(":id", id)}`,

  LEAVE_APPROVAL_PROCESS,
  LEAVE_APPROVAL_PROCESS_EDIT: (id: string) =>
    `${LEAVE_APPROVAL_PROCESS}/${EDIT.replace(":id", id)}`,

  CALENDAR_HOLIDAYS,
  CALENDAR_HOLIDAYS_EDIT: (id: string) =>
    `${CALENDAR_HOLIDAYS}/${EDIT.replace(":id", id)}`,

  REALMS,
  REALMS_EDIT: (id: string) => `${REALMS}/${EDIT.replace(":id", id)}`,
  REALMS_DETAIL: (id: string) => `${REALMS}/${DETAIL.replace(":id", id)}`,

  ANNOUNCEMENT,
  ANNOUNCEMENT_EDIT: (id: string) =>
    `${ANNOUNCEMENT}/${EDIT.replace(":id", id)}`,
  ANNOUNCEMENT_SURVEY: (id: string) =>
    `${ANNOUNCEMENT}/${SURVEY.replace(":id", id)}`,

  BULK_LEAVES,
  ACTIVITY,

  LEAVE_RIGHT_REPORTS,
  GUEST_ENTRANCE_REPORTS,
  EMPLOYMENT_START_REPORTS,
  USER_LEAVE_REPORTS,
  EMPLOYEE_SHIFT_REPORTS,
  PUANTAJ,
  DAILY_SHIFTS,

  APP_VERSION,
  APP_VERSION_CREATE: `${APP_VERSION}/${CREATE}`,
  APP_VERSION_EDIT: (platform: string) =>
    `${APP_VERSION}/${EDIT.replace(":id", platform)}`,

  VERSION_CHECK,

  SALARY_ACCOUNT,
  MIKRO_PERSONNEL_SYNC,
};
